import { UserType } from '@/generated/graphql';

export const TASK_DONE_FILTER = {
	Done: 'done',
	NotDone: 'notDone',
	All: 'all',
} as const;

export const TASKS_ASSIGNEE_FILTER_USER_TYPES = [UserType.User, UserType.Admin];
